import { render, staticRenderFns } from "./FIBFinalBox.vue?vue&type=template&id=543b0e1b&scoped=true&"
import script from "./FIBFinalBox.vue?vue&type=script&lang=js&"
export * from "./FIBFinalBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543b0e1b",
  null
  
)

export default component.exports